import styled from 'styled-components';

import { NewStyleColor, StyleColor, macTopBarHeight } from '../../../utils/styles-constants';
import { HEADER_HEIGHT } from '../styles';
import Utils from '../../../utils';
import { hexToRgba } from '../../../utils/style';
import UserAgentUtils from '../../../utils/userAgent';

interface HeaderButtonProps {
	disabled: boolean;
	iconWidth: string;
	iconHeight: string;
	color?: string;
}

const Wrapper = styled('div')`
	box-sizing: border-box;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${HEADER_HEIGHT}px;
	padding: 0 12px;
	border-bottom: 1px solid ${hexToRgba(StyleColor.Grey450, 50)};
	background-color: ${NewStyleColor.Black};
	font-family: HelveticaNeue, sans-serif;
	color: ${NewStyleColor.White};

	${Utils.isEmbedMode() && 'padding-right: 20px;'}
	${UserAgentUtils.isMacApp() && `padding-top: ${macTopBarHeight};`}
`;

const ButtonsGroup = styled('div')`
	display: flex;
	align-items: center;

	& + & {
		margin-left: 20px;
	}
`;

const HeaderButton = styled('button').attrs({
	type: 'button',
})`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 35px;
	width: 35px;
	height: 35px;
	padding: 0;
	border: 0;
	border-radius: 6px;
	outline: 0;
	background-color: ${hexToRgba(NewStyleColor.White, 12)};
	color: ${({ color }: HeaderButtonProps) => color || NewStyleColor.White};
	cursor: pointer;

	${({ disabled }: HeaderButtonProps) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	svg {
		width: ${({ iconWidth }: HeaderButtonProps) => iconWidth};
		height: ${({ iconHeight }: HeaderButtonProps) => iconHeight};
		fill: currentColor;
		margin: 0;
	}

	& + & {
		margin-left: 6px;
	}
`;

export {
	Wrapper,
	ButtonsGroup,
	HeaderButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Header/styles.ts